import { EndpointCallParams } from '@core/api/endpointCallParams';
import { IApiStore } from '@core/api/apiStore';

import { IntegrationProcedure } from 'Integrations/domain/IntegrationProcedure';
import { IntegrationExportSettings } from 'Integrations/domain/IntegrationExportSettings';

/** The request body, PascalCased exactly as the endpoint expects it. */
export type ExportProceduresBody = {
    Split: string;
    CreateWbtCourse: boolean;
    PlayerTemplate: string;
    ContentFolder: string;
    ContentProvider: string;
    ContentServer: string;
    Owner: string;
    ProceduresList: IntegrationProcedure[];
};

export type ExportProceduresParams = {
    deploymentId: string;
    settings: IntegrationExportSettings;
    procedures: IntegrationProcedure[];
};

export const buildExportProceduresBody = (
    settings: IntegrationExportSettings,
    procedures: IntegrationProcedure[],
): ExportProceduresBody => ({
    Split: settings.split,
    CreateWbtCourse: settings.createWbtCourse,
    PlayerTemplate: settings.playerTemplate,
    ContentFolder: settings.contentFolder,
    ContentProvider: settings.contentProvider,
    ContentServer: settings.contentServer,
    Owner: settings.owner,
    ProceduresList: procedures,
});

export const performExportProcedures = async (
    api: IApiStore,
    params: EndpointCallParams<ExportProceduresParams>,
) => {
    const { payload, ...rest } = params;

    // The endpoint answers with a CSV file, hence postBlob rather than post.
    return api.postBlob(
        `xapi/integration/deployments/${payload.deploymentId}/exportProcedures`,
        {
            ...rest,
            payload: buildExportProceduresBody(payload.settings, payload.procedures),
        },
    );
};
